<template>
  <svg :width="width" :height="height" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.1429 17.5V19.0625C12.1429 19.5803 11.7351 20 11.2321 20H0.910714C0.407734 20 0 19.5803 0 19.0625V4.6875C0 4.16973 0.407734 3.75 0.910714 3.75H3.64286V15.3125C3.64286 16.5187 4.59611 17.5 5.76786 17.5H12.1429ZM12.1429 4.0625V0H5.76786C5.26488 0 4.85714 0.419727 4.85714 0.9375V15.3125C4.85714 15.8303 5.26488 16.25 5.76786 16.25H16.0893C16.5923 16.25 17 15.8303 17 15.3125V5H13.0536C12.5527 5 12.1429 4.57812 12.1429 4.0625ZM16.7333 2.85043L14.231 0.27457C14.0602 0.0987666 13.8286 1.29998e-06 13.5871 0L13.3571 0V3.75H17V3.51332C17 3.26469 16.9041 3.02624 16.7333 2.85043Z" fill="#80B7FF"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 17 },
        height: { type: [Number, String], default: 20 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
